import React, { useCallback } from 'react'
import { Image } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import Pressable from '@zet/design-system/pressable'
import { APP_NAME } from '@zet/end-points'
import { navigateTo } from '@zet/utils/navigation'

const ReferAndEarnBanner = ({
  containerClassName,
}: {
  containerClassName?: string
}) => {
  const navigate = useCallback(() => {
    navigateTo('Network')
  }, [])

  return (
    <>
      {APP_NAME !== MY_TEAMS_ADVISOR ? (
        <Pressable
          onPress={navigate}
          className={`${
            containerClassName ? containerClassName : ''
          } items-center justify-center bg-white`}
        >
          <Image
            source={{
              uri: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/Referral+Banner.png',
            }}
            style={{
              width: '90%',
              height: 150,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            resizeMode="contain"
          />
        </Pressable>
      ) : null}
    </>
  )
}

export default ReferAndEarnBanner
